import { ProfilePicture } from "../Types/ProfilePicture";

type Props = { data: ProfilePicture };

export default function ProfilePictureComponent({ data }: Props) {
  return (
    <section className="cv-section">
      <div className="cv-card p-6 text-center">
        <img
          src={data.image.src}
          alt={data.image.title}
          title={data.image.title}
          className="cv-avatar-img mt-4"
        />
      </div>
    </section>
  );
}
